import { jsx as e } from "react/jsx-runtime";
const i = (r) => e("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1.5em", height: "1.5em", fill: "currentColor", viewBox: "0 0 24 24", focusable: "false", "aria-hidden": "true" }, r, { children: e("path", { fill: "inherit", d: "m12 15-5-5h10z" }) }));
export {
  i as default
};
